import React from 'react';
import { css } from '@emotion/core';
import { FadeLoader } from 'react-spinners';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AddressField from '../../components/address-field/address-field';
import ButtonPrimary from '../../components/buttons/button-primary';
import {
  receivedLogUserIn,
  saveRoom,
  saveAdmin,
  saveLoggedUser,
  saveUser,
} from '../../../store/actions/user-actions';
import ButtonSecondary from '../../components/buttons/button-secondary';
import Requests from '../../../api/requests';
import Modal from '../../components/modal/modal';
import PopupOneButton from '../../components/popup/popup-one-button';
import { selectKey } from '../../../utilities/helper';
import './address-confirmation.scss';

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    { saveRoom, saveAdmin, receivedLogUserIn, saveLoggedUser, saveUser },
    dispatch,
  );
};

const parseJwt = token => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};

class AddressConfirmation extends React.Component {
  constructor() {
    super();

    this.state = {
      selectedIndex: null,
      addresses: [],
      address: '',
      index: 0,
      modalIndex: 0,
      hasError: false,
      hasInvalidParams: false,
      hasContent: false,
      loading: false,

      // PSI parameters
      remote_proctor_service_id: '',
      email: '',
      activation_code: '',
    };
  }

  componentDidMount = async () => {
    if (this.props.userStore.hasUserLoggedOut || !this.props.userStore.admin) {
      this.setState({
        hasInvalidParams: true,
      });
      return;
    }
    window.addEventListener('keydown', this.keySelect);

    const query = new URLSearchParams(this.props.location.search);
    const remote_proctor_service_id = query.get('remote_proctor_service_id');
    const email = decodeURIComponent(query.get('email'));
    const activation_code = decodeURIComponent(query.get('activation_code'));

    const { saveAdmin, saveLoggedUser, saveUser, saveRoom } = this.props;
    const admin = this.props.userStore.admin;

    if (
      admin &&
      !admin.token &&
      activation_code &&
      email &&
      remote_proctor_service_id
    ) {
      const {
        ok: confirm,
        json: relaunchToken,
        status: relaunchStatus,
      } = await Requests.relaunch({
        activation_code,
        email,
        remote_proctor_service_id,
      });

      if (confirm) {
        admin.token = relaunchToken.token;
        const relaunch_admin = { ...parseJwt(relaunchToken.token) };
        if (relaunch_admin) {
          admin.admin_id = relaunch_admin.admin;
          admin.reg_id = relaunch_admin.reg;
        }

        const userRequestBody = {
          admin_id: admin.admin_id,
          reg_id: admin.reg_id,
          token: admin.token,
        };

        const {
          ok: userReceived,
          json: userData,
          status: userRequestStatus,
        } = await Requests.getUser(userRequestBody);

        if (userReceived) {
          admin.ts_and_cs_ind = userData.ts_and_cs_ind;
          saveAdmin(admin);

          const loggedUser = {
            name: userData.name,
            testLocation: userData.testLocation,
            testTaking: userData.testTaking,
            photo: userData.photo,
            delivery_type: userData.delivery_type,
            tlp_params: userData.tlp_params,
            launch_tz: userData.launch_tz,
            auto_launch_ind: userData.auto_launch_ind,
            timing_modifier: userData.timing_modifier,
            rp_session_status: userData.rp_session_status,
            rp_session_status_retry_duration:
              userData.rp_session_status_retry_duration,
            rp_session_status_retry_limit:
              userData.rp_session_status_retry_limit,
          };
          if (userData.delivery_type === 'Remote' && userData.room_no) {
            let roomValue = userData.delivery_type + '-' + userData.room_no;
            saveRoom(roomValue);
          }
          saveLoggedUser(true);
          saveUser(loggedUser);
        } else {
          if (userRequestStatus === 400 || userRequestStatus === 403) {
            this.setState({ hasInvalidParams: true });
          }
          if (userRequestStatus === 500) {
            this.setState({ hasError: true });
          }
          return;
        }
      } else {
        if (relaunchStatus === 400 || relaunchStatus === 403) {
          this.setState({ hasInvalidParams: true });
        }
        if (relaunchStatus === 500) {
          this.setState({ hasError: true });
        }
        return;
      }
    } else if (!admin || !admin.admin_id) {
      this.setState({ hasInvalidParams: true });
      return;
    }

    const user = {
      admin_id: admin.admin_id,
      reg_id: admin.reg_id,
      token: admin.token,
    };
    setTimeout(() => {
      this.setState({
        loading: true,
      });
    }, 400);
    const { ok, json: body, status } = await Requests.getAddress(user);
    if (document.getElementById('title')) {
      setTimeout(() => {
        document.getElementById('title').focus();
      }, 2000);
    }

    if (ok) {
      if (status === 200) {
        this.setState({
          addresses: body.addresses,
          hasContent: true,
          loading: false,
        });
      }
    } else {
      if (status === 400 || status === 403) {
        this.setState({ hasInvalidParams: true });
      }
      if (status === 500) {
        this.setState({ hasError: true });
      }
    }
  };

  componentWillUnmount() {
    window.removeEventListener('keydown', this.keySelect);
  }

  toggleSelect = (index, event) => {
    if (this.state.selectedIndex !== index) {
      this.setState({ selectedIndex: index });
      document.getElementById('button-primary').focus();
    } else {
      this.setState({ selectedIndex: null });
    }
    this.setState({ address: event.target.textContent });
  };

  goBack = () => {
    window.history.back();
  };

  goNext = async () => {
    const admin = this.props.userStore.admin;
    const user = {
      admin_id: admin.admin_id,
      reg_id: admin.reg_id,
      token: admin.token,
      address: this.state.address,
    };
    const { ok, status } = await Requests.putAddress(user);

    if (ok) {
      if (status === 204) {
        if (this.props.userStore.admin.ts_and_cs_ind) {
          this.props.history.push('/test-launcher');
        } else {
          this.props.history.push('/terms-and-conditions');
        }
      }
    } else {
      if (status === 403) {
        this.setState({ hasInvalidParams: true });
      }
      if (status === 400) {
        this.setState({ hasError: true });
      }
    }
  };

  setIndex = index => {
    this.setState({ index: index });
  };

  setModalIndex = index => {
    this.setState({ modalIndex: index });
  };

  keySelect = event => {
    const ids =
      this.state.selectedIndex === null
        ? [
            'address-field-1',
            'address-field-2',
            'address-field-3',
            'address-field-4',
            'button-secondary',
            'logout',
          ]
        : [
            'address-field-1',
            'address-field-2',
            'address-field-3',
            'address-field-4',
            'button-secondary',
            'button-primary',
            'logout',
          ];

    let focusedElement = document.activeElement.id;
    const arrows = ['ArrowRight', 'ArrowLeft'];
    const isModalOpen = this.props.headerStore.isModalOpen;
    if (
      this.state.index <= ids.length - 1 &&
      this.state.index >= 0 &&
      !isModalOpen
    ) {
      selectKey(
        event,
        this.state.index,
        ids,
        focusedElement,
        this.setIndex,
        arrows,
      );
    }
  };

  modalNavigation = event => {
    const ids = ['button-primary-modal', 'button-secondary-modal'];
    const focusedElement = document.activeElement.id;
    const arrows = ['ArrowDown', 'ArrowUp'];
    if (this.state.modalIndex <= ids.length - 1 && this.state.modalIndex >= 0) {
      selectKey(
        event,
        this.state.modalIndex,
        ids,
        focusedElement,
        this.setModalIndex,
        arrows,
      );
    }
  };

  closeErrorModal = () => {
    this.setState({ hasError: false });
    this.props.history.push('/');
  };

  closeInvalidModal = () => {
    this.setState({ hasInvalidParams: false, modalIndex: 0 });
    this.props.history.push('/');
  };

  refreshPage = () => {
    window.location.reload();
  };

  render() {
    const addresses = this.state.addresses;
    const isDisabled = this.state.selectedIndex === null;
    const override = css`
      display: block;
      margin: 0 auto;
    `;
    return !this.state.hasError && this.state.hasContent ? (
      <main className="address-confirmation">
        <h1 className="title" id="title">
          Which one of the following addresses is associated with your ACT
          account:
        </h1>
        <div className="agree-terms" id="agree-terms">
          {' '}
        </div>
        <div className="address-fields-container">
          {addresses.map((address, i) => {
            return (
              <AddressField
                text={address}
                key={i}
                index={i}
                isSelected={this.state.selectedIndex === i}
                handler={this.toggleSelect}
              />
            );
          })}
        </div>

        <div className="buttons-container">
          <ButtonSecondary
            buttonText="Back"
            hasArrow={true}
            onClick={this.goBack}
            tabIndex={5}
          />
          <ButtonPrimary
            buttonText="Continue"
            hasArrow={true}
            isDisabled={isDisabled}
            onClick={this.goNext}
            tabIndex={isDisabled ? -1 : 6}
          />
        </div>
      </main>
    ) : (
      <div>
        <div className="spinner-container">
          <FadeLoader
            css={override}
            size={'350px'}
            sizeUnit="px"
            color="#042E60"
            loading={this.state.loading}
            height={30}
            width={7}
            margin={20}
          />
        </div>
        <Modal
          isOpen={this.state.hasError}
          className={'modal-content one-button'}
          ariaProps={{
            modal: true,
          }}
          child={
            <PopupOneButton
              title="Invalid data"
              description="Something went wrong. Please try again."
              buttonText="Go To Sign In"
              padding="0 75px"
              onClick={this.closeErrorModal}
            />
          }
        />
        <Modal
          isOpen={this.state.hasInvalidParams}
          className={'modal-content one-button'}
          ariaProps={{
            modal: true,
          }}
          child={
            <PopupOneButton
              title="Invalid information"
              description="Invalid user information. Please sign in again."
              buttonText="Go To Sign In"
              padding="0 75px"
              onClick={this.closeInvalidModal}
            />
          }
        />
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddressConfirmation);
